import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Card } from 'antd';
import { Row, Col } from 'react-bootstrap';
import { PiInfoDuotone  } from 'react-icons/pi';

const CardEmptyResult = ({ title = 'No results', subtitle = '', icon = null } = {}) => {

    const renderIcon = () => {
        if (!icon) {
            return <PiInfoDuotone className="fs-2 text-secondary" />;
        }
        
        // If icon is already a React element (JSX), render it directly
        if (React.isValidElement(icon)) {
            return icon;
        }
        
        // If icon is a component type, render it as a component
        const IconComponent = icon;
        return <IconComponent className="fs-2 text-secondary" />;
    };

    return (
        <Fragment>
            <Card size="small" className="rounded-3 shadow-none" style={{  opacity: 0.4 }}>
                    <Row className="g-3 align-items-center">
                        <Col xs="auto">
                            <div 
                                className="rounded-3 d-flex align-items-center justify-content-center"
                                style={{
                                    width: '64px',
                                    height: '64px',
                                    backgroundColor: 'var(--varexe-gray-100, #f8f9fa)'
                                }}
                            >
                                {renderIcon()}
                            </div>
                        </Col>
                        <Col>
                            <div className=" font-sans-serif mb-1">
                                {title || 'No results'}
                            </div>
                            {subtitle && (
                                <div className="text-800 font-sans-serif fw-semi-bold">
                                    {subtitle}
                                </div>
                            )}
                        </Col>
                    </Row>
            </Card>
        </Fragment>
    );
};

CardEmptyResult.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    icon: PropTypes.oneOfType([
        PropTypes.elementType,
        PropTypes.element,
    ]),
};

export default CardEmptyResult;

